import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	allRemainingIssues: {
		id: 'servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.jql.all-remaining-issues',
		defaultMessage: 'All remaining issues',
		description: 'jql message displayed for default goal',
	},
	errorTooltip: {
		id: 'servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.jql.error-tooltip',
		defaultMessage: 'This goal has one or more errors.',
		description:
			'message displayed in tooltip when a priority gets updated and still old value is being in a Subgoal',
	},
	warningWhenPriorityIsPresentInJqlWithSubGoals: {
		id: 'servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.jql.warning-when-priority-is-present-in-jql-with-sub-goals',
		defaultMessage:
			'This goal’s priority field creates a conflict with one of its priority time targets.',
		description:
			'message shown as tooltip for warning icon when priority is present in parent JQL and has a subgoal',
	},
});
